import { StatusMeta } from './status-meta.types';

/**
 * The outbound email log as Ops and Admin read it — one shape for the Kickstart
 * application trail, the Debtors Finance facility trail and the admin page.
 */
export type EmailSendStatus = 'SENT' | 'FAILED' | 'HELD';

export const EMAIL_SEND_STATUS_META: Record<EmailSendStatus, StatusMeta> = {
  SENT: { label: 'Sent', variant: 'success' },
  FAILED: { label: 'Failed', variant: 'destructive' },
  HELD: { label: 'Held for approval', variant: 'warning' },
};

interface OpsEmailClick {
  url: string;
  user_agent: string;
  created_at: string;
}

export interface OpsEmailLogEntry {
  id: string;
  to_email: string;
  subject: string;
  category: string;
  category_display: string;
  status: EmailSendStatus;
  error: string;
  html_body: string;
  text_body: string;
  click_count: number;
  last_clicked_at: string | null;
  clicks: OpsEmailClick[];
  created_at: string;
}
